import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MemoRow from './row';
import { updateGrid as updateG, updateDestination, setData } from '../../redux/bulkBookingSlice';
import { isRealObject } from '../../global';
import { setLoading } from '../../redux/appSlice';
import { getTarrif } from '../../services/bookingservice';

const Grid = ({validateExcel}) => {
    const dispatch = useDispatch();
    const { services } = useSelector(state => state.appData);
    const state = useSelector(state => { return { appData: state.appData, bulkBookingData: state.bulkBookingData } });
    const { destinations, userInfo } = state.appData;
    const {
        data,
        grid } = state.bulkBookingData;

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    };

    const updateData = (key, val) => {
        const d = { ...data, [key]: val };
        dispatch(setData({ data: d }));
    };


    const updateDest = (index, val) => {
        dispatch(updateDestination({ index, val, dests: destinations }));
    }

    const validateTarrif = (destination, serviceType, weight) => {
        if (!data.subAccountId) {
            alert('Sub Account is required');
            return false;
        }
        if (!data.locationId) {
            alert('Location is required');
            return false;
        }
        if (!destination) {
            alert('Destination is required');
            return false;
        }
        if (!serviceType) {
            alert('Select Service Type');
            return false;
        }
        if (!weight || data.weight <= 0) {
            alert('Weight is required');
            return false;
        } else {
            const w = data.isCod ? 99 : 9999;
            if (data.weight > w) {
                alert('Weight is greater than ' + w);
                return false;
            }
        }
        return true;
    }

    const onTarrifLoad = async () => {
        if (validateExcel("loadTarrif")) {

            grid.map(async (x, index) => {
                updateGrid(index, 'shouldTarrifLoad', false)
                if (validateTarrif(x.DestinationCity, x.ServiceType, x.Weight)) {
                    const tarrifPayload = {
                        account: data.accountNo,
                        origin: data.branch,
                        destination: String(destinations.find(y => y.text.toUpperCase() == x.DestinationCity.toUpperCase()).value),
                        serviceType: x.ServiceType,
                        weight: x.Weight,
                    };
                    dispatch(setLoading({ data: true }));
                    const rs = await getTarrif(tarrifPayload);
                    dispatch(setLoading({ data: false }));
                    if (rs.ok && isRealObject(rs.data)) {
                        const { amount, gst, msg } = rs.data
                        if (msg === "Success" && amount && gst) {
                            if (!data.tarrifLoaded) {
                                updateData("tarrifLoaded", true)
                            }
                            updateGrid(index, 'totalAmount', amount)
                            updateGrid(index, 'gst', gst)
                            updateGrid(index, 'chargeAmount', amount + gst)
                        } else {
                            updateData("tarrifLoaded", false)
                            alert(rs.data.msg)
                        }
                    } else {
                        alert(rs.msg);
                    }
                }
            })
        }
    }

    const onSingleTarrifLoad = async (index, row) => {
        if (validateExcel("loadTarrif")) {
            const tarrifPayload = {
                account: data.accountNo,
                origin: data.branch,
                destination: String(destinations.find(y => y.text.toUpperCase() == row.DestinationCity.toUpperCase()).value),
                serviceType: row.ServiceType,
                weight: row.Weight,
            };
            dispatch(setLoading({ data: true }));
            const rs = await getTarrif(tarrifPayload);
            dispatch(setLoading({ data: false }));
            if (rs.ok && isRealObject(rs.data)) {
                const { amount, gst, msg } = rs.data
                if (msg === "Success" && amount && gst) {
                    if (!data.tarrifLoaded) {
                        updateData("tarrifLoaded", true)
                    }
                    updateGrid(index, 'totalAmount', amount)
                    updateGrid(index, 'gst', gst)
                    updateGrid(index, 'chargeAmount', amount + gst)
                    updateGrid(index, 'shouldTarrifLoad', false)
                } else {
                    updateGrid(index, 'shouldTarrifLoad', false)
                    updateData("tarrifLoaded", false)
                    alert(rs.data.msg)
                }
            } else {
                alert(rs.msg);
            }
        }
    }

    const findDuplicates = (CustomerReferenceNumber) => {
        const arrayForSort = [...grid]
        let sorted_grid = arrayForSort.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => ({ index, CustomerReferenceNumber: x.CustomerReferenceNumber })).sort(function (a, b) {
            return ('' + a.CustomerReferenceNumber).localeCompare(b.CustomerReferenceNumber);
        });
        let results = [];
        for (let i = 0; i < sorted_grid.length - 1; i++) {
            if (sorted_grid[i + 1].CustomerReferenceNumber == sorted_grid[i].CustomerReferenceNumber) {
                results.push(sorted_grid[i]);
            }
        }
        return results.findIndex(d => d.CustomerReferenceNumber.trim().toUpperCase() == CustomerReferenceNumber.trim().toUpperCase()) !== -1;
    }

    return <div className="row mt-2">
        <div className="table-responsive" style={{ maxHeight: "450px" }}>
            <table className="table">
                <thead>
                    <tr>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Serial No</th>
                        {
                            data.autoCN === false && <th>Consignment No</th>
                        }
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Name</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Address</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Mobile Number</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Email</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Destination City</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Pieces</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Weight</th>
                        {data.isCod && <th className="th-sticky" style={{ background: "#f5f5f5" }}>COD Amount</th>}
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Customer Reference Number</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Special Handling</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Service Type</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Product Details</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Remarks</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Total Amount</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>GST</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Charge Amount</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>
                            <button type="button" className="btn btn-primary" style={{ marginLeft: 2, width: 100 }} disabled={grid.length <= 0} onClick={onTarrifLoad}>Load Tarrif</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        grid.map((x, index) => <MemoRow key={index} x={{ ...x, isCod: data.isCod }} findDuplicates={findDuplicates} formData={data} index={index} services={services} destinations={destinations} user={userInfo} autoCN={data.autoCN} updateGrid={updateGrid} updateDest={updateDest} onSingleTarrifLoad={onSingleTarrifLoad} />)
                    }
                </tbody>
            </table>
        </div>
    </div>
}

export default Grid;
